import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { map, switchMap, of, Observable, combineLatest } from 'rxjs';
import { DeviceService } from 'src/app/devices/services/device.service';
import { catchError, debounceTime, tap } from 'rxjs/operators';
import { IBaseSearchRequest } from 'src/app/core/models/base';
import { IDeviceCategory } from 'src/app/devices/models/device-category';
import { IDeviceManufacturer } from 'src/app/devices/models/device-manufacturer';

export function DeviceSerialNumberValidator(deviceService: DeviceService): AsyncValidatorFn {
    return (control: AbstractControl) => {

      var parentFormControl = control.parent;
      var manufacturerId = parentFormControl.get('deviceManufacturerId').value

        // Check if the serial number is empty
        if (!control.value || control.value.trim() === '') {
            return of({ serialNumberRequired: true }); // Return an error if the serial number is empty
        }

        // dont validate when not touched
        if(control.pristine){
        return of(null);
    }

      // Perform the uniqueness check for the serial number
      const request: IBaseSearchRequest = {
          pageNumber: 0,
          pageSize: 999999,
          advancedFilter: {
              logic: 'and',
              filters: [
                  {
                      field: 'serialNumber',
                      operator: 'eq',
                      value: control.value
                  },
                  {
                      field: 'manufacturerId',
                      operator: 'eq',
                      value: manufacturerId
                  },
                  {
                    field: 'deviceCategory.hasSerialNumber',
                    operator: 'eq',
                    value: true
                  }
              ]
          }
      };

      // to check for duplicate if its a new device
      var deviceId = control.parent?.get('id')?.value;
      if(deviceId){
        request.advancedFilter.filters.push({
            field: 'id',
            operator: 'neq',
            value: deviceId
        })
      }

      return deviceService.getDevices(request).pipe(
          map(response => {
              const deviceExists = response.data.length > 0;
              return deviceExists ? { serialNumberExists: true } : null;
          }),
          catchError(() => of(null)) // Handle errors by returning null
      );
      
    };
}